import React, { useRef, useEffect } from 'react';
import { Container } from 'reactstrap';
import { getAssetUrl } from '../../services/cdn';

const Maps = () => {


  return (
    <div className="branches-map" style={{display: "flex", height: "400px", width: "100%" }}>
        <iframe
            title="KoopSiklo Gulod Branch"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d182.60212224399143!2d121.07470952320769!3d13.759086573169904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sph!4v1754623533430!5m2!1sen!2sph"
            width="80%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
        </iframe>
        <div className='store-wrapper' style={{display: "flex", flexDirection: "column", justifyContent: "center", flex: "1 1 50%", padding: "20px", background: "#80C341", width: "20%" }}>
          <div style={{ marginBottom: "20px" }} >
            <h3 style={{fontWeight: 400}}>KoopSiklo Gulod</h3>
            <p>Brgy. Gulod, Labak, Batangas City, Batangas</p>
            <p>0998-860-6547</p>
          </div>
          <div>
            <h3 style={{fontWeight: 400}}>KoopSiklo Zaragoza</h3>
            <p>Brgy. del Pilar, Zaragoza, Nueva Ecija</p>
            <p>0998-978-7353</p>
          </div>
        </div>
    </div>
  );
};

export default Maps;
